export const GET_DIESEL_PENDING = "GET_DIESEL_PENDING"
export const GET_DIESEL_SUCCESS = "GET_DIESEL_SUCCESS"
export const GET_DIESEL_FAILURE = "GET_DIESEL_FAILURE"

export const GET_DIESEL_PUMP_NAME_PENDING = "GET_DIESEL_PUMP_NAME_PENDING"
export const GET_DIESEL_PUMP_NAME_SUCCESS = "GET_DIESEL_PUMP_NAME_SUCCESS"
export const GET_DIESEL_PUMP_NAME_FAILURE = "GET_DIESEL_PUMP_NAME_FAILURE"

export const ADD_DIESEL_PENDING = "ADD_DIESEL_PENDING"
export const ADD_DIESEL_SUCCESS = "ADD_DIESEL_SUCCESS"
export const ADD_DIESEL_FAILURE = "ADD_DIESEL_FAILURE"

export const UPLOAD_DIESEL_PENDING = "UPLOAD_DIESEL_PENDING"
export const UPLOAD_DIESEL_SUCCESS = "UPLOAD_DIESEL_SUCCESS"
export const UPLOAD_DIESEL_FAILURE = "UPLOAD_DIESEL_FAILURE"

export const EDIT_DIESEL_PENDING = "EDIT_DIESEL_PENDING"
export const EDIT_DIESEL_SUCCESS = "EDIT_DIESEL_SUCCESS"
export const EDIT_DIESEL_FAILURE = "EDIT_DIESEL_FAILURE"

export const DELETE_DIESEL_PENDING = "DELETE_DIESEL_PENDING"
export const DELETE_DIESEL_SUCCESS = "DELETE_DIESEL_SUCCESS"
export const DELETE_DIESEL_FAILURE = "DELETE_DIESEL_FAILURE"

export const DOWNLOAD_DIESEL_PENDING = "DOWNLOAD_DIESEL_PENDING"
export const DOWNLOAD_DIESEL_SUCCESS = "DOWNLOAD_DIESEL_SUCCESS"
export const DOWNLOAD_DIESEL_FAILURE = "DOWNLOAD_DIESEL_FAILURE"
